<!--Heatmap widget-->
<div class="heatmap-content" [style.--heat-color]="scaleColor || null" #htmlContent>
  @if (isLoading()) {
  <app-widget-loading [graphType]="widget?.graphType"></app-widget-loading>
  } @else {
  <header class="heatmap-head">
    @if (showTitle) {
    @if (richTitle && showTitle) {
    <app-widget-title class="flush" [title]="title" [design]="widget?.design?.title"></app-widget-title>
    } @else {
    <p class="heatmap-title" [style]="titleStyle">{{ title }}</p>
    }
    }

    @if (peak) {
    <span class="heatmap-peak">{{ 'editor.heatmap_peak' | translate: { column: peak.column, value: peak.value }
      }}</span>
    }
  </header>

  @if (error) {
  <span class="error">{{ error }}</span>
  }

  <div class="heatmap-grid" [style.--columns]="columns.length">
    @for (row of rows; track row.label) {
    <span class="heatmap-row-label" [title]="row.label">{{ row.label }}</span>
    @for (value of row.values; track $index) {
    <span class="heatmap-cell" [ngClass]="'level-' + level(value)" [class.peak]="isPeak(value)"
      (mouseenter)="hover(row, columns[$index]!, value, $event)" (mouseleave)="hovered = null"></span>
    }
    }

    @if (hovered) {
    <lib-tooltip [x]="hovered.x" [y]="hovered.y">
      @if (hovered.row) {
      <strong>{{ hovered.row }}</strong>
      }
      <span class="tooltip-detail">{{ hovered.column }}</span>
      <span class="tooltip-value">{{ hovered.value | number }}</span>
    </lib-tooltip>
    }

    <span></span>
    @for (column of columns; track column.key; let index = $index) {
    <span class="heatmap-axis">{{ index % axisStep === 0 ? column.label : '' }}</span>
    }
  </div>

  <footer class="heatmap-legend">
    {{ 'editor.heatmap_intensity' | translate }} :
    <span class="heatmap-cell level-0"></span> 0
    <span class="heatmap-cell level-1"></span> {{ 'editor.heatmap_low' | translate }}
    <span class="heatmap-cell level-2"></span> {{ 'editor.heatmap_medium' | translate }}
    <span class="heatmap-cell level-3"></span> {{ 'editor.heatmap_high' | translate }}
  </footer>
  }

  @if (widgetRendered && !isLoading()) {
  <div id="chart-rendered"></div>
  }
</div>